import React, { useEffect } from "react";
import { connect } from "react-redux";

import MobileAppVersions from "./MobileAppVersions";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../redux/actions/menuActions";
import Menu from "../devs/Menu";

const MobileAppVersionsContainer = props => {
  useEffect(() => {
    props.setMenuTopIndex("devs");
    props.setMenuLeftContent(Menu);
    props.setMenuLeftIndex("appversions");
    props.setMenuLeftItemIndex("");
  }, []);
  return <MobileAppVersions {...props} />;
};

const mapStateToProps = state => {
  const userInfos = state.userInfos || {};

  return {
    token: state.auth.token,
    clients: userInfos.clients || []
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppVersionsContainer);



// WEBPACK FOOTER //
// src/pages/mobileAppVersions/MobileAppVersions.container.js